import * as React from "react";
import { Cta } from "../Cta";

/* istanbul ignore next */
export class Region extends React.Component<{
    label: string
    handler: Function
    selected?: boolean
}, {}> {
    /* istanbul ignore next */
    render() {
        return (
            <div className="racing-region-selector__region" onClick={() => this.props.handler()}>
                <Cta label={this.props.label} selected={this.props.selected} />
            </div>
        )
    }
}